define('OutSystems/ClientRuntime/modules/Common/IndexedStack',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedStack = (function () {
        function IndexedStack() {
            this.stack = [];
            this.map = {};
            this.counter = 0;
        }
        IndexedStack.prototype.push = function (value) {
            var index = this.counter++;
            this.stack.push(index);
            this.map[index] = value;
            return index;
        };
        IndexedStack.prototype.remove = function (index) {
            var idx = this.stack.indexOf(index);
            var found = idx > -1;
            if (found) {
                this.stack.splice(idx, 1);
                delete this.map[index];
            }
            return found;
        };
        IndexedStack.prototype.pop = function () {
            if (this.stack.length === 0) {
                throw new Error("IndexedStack: pop from empty stack.");
            }
            var index = this.stack.pop();
            var value = this.map[index];
            delete this.map[index];
            return value;
        };
        IndexedStack.prototype.clear = function () {
            this.stack = [];
            this.map = {};
        };
        Object.defineProperty(IndexedStack.prototype, "isEmpty", {
            get: function () {
                return this.stack.length === 0;
            },
            enumerable: false,
            configurable: true
        });
        return IndexedStack;
    }());
    exports.default = IndexedStack;
});
//# sourceMappingURL=IndexedStack.js.map;
